import "core-js/modules/es7.object.get-own-property-descriptors";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.object.keys";
import _toConsumableArray from "D:/java/\u4E00\u7F51\u901A\u529E(\u529E\u4E8B\u5927\u53852.0)/\u4E00\u7F51\u901A\u529E\u524D\u7AEFPC/pc/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "D:/java/\u4E00\u7F51\u901A\u529E(\u529E\u4E8B\u5927\u53852.0)/\u4E00\u7F51\u901A\u529E\u524D\u7AEFPC/pc/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _defineProperty from "D:/java/\u4E00\u7F51\u901A\u529E(\u529E\u4E8B\u5927\u53852.0)/\u4E00\u7F51\u901A\u529E\u524D\u7AEFPC/pc/node_modules/@babel/runtime/helpers/esm/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

//
//
//
//
//
//
//
//
//
import { mapGetters, mapActions } from "vuex";
import Header from "@/components/public/Header";
import AddRouterFunc from "@/router/addRouter";
export default {
  name: "App",
  props: [],
  components: {
    Header: Header
  },
  data: function data() {
    return {
      // 点击当前连接刷新
      refreshActive: true
    };
  },
  computed: _objectSpread({}, mapGetters(["userToken", "userData", "theme", "accessToken"])),
  created: function created() {
    var _this = this;

    // 接口返回拦截
    this.$http.interceptors.response.use(function (response) {
      if (response.data.resCode == 601) {
        _this.logout();
      } else if (response.data.resCode == 0 || response.data.resCode == -1003 || response.data.token_type === "bearer") {} else if (response.headers["content-type"] === "application/octet-stream;charset=utf-8") {// 判断文件流
      } else {
        _this.$message.error(response.data.resMsg);
      }

      return response;
    }, function (error) {
      if (error.response) {
        switch (error.response.status) {
          case 401:
            // 登录超时
            _this.logout();

            break;

          case 402:
            // keycloak的刷新token过期会返回402，刷新页面重新请求一次新accessToken
            window.location.reload();
            break;

          case 403:
            // 登录超时
            _this.$message.error("权限不足，请联系管理员");

            break;

          default:
            // this.logout();
            _this.$message.error(error.response.data.message);

        }
      }

      return Promise.reject(error.response.data);
    });

    if (this.userToken) {
      this.$http.defaults.headers.common["token"] = this.userToken;
      this.fetchUserData();
    } else {
      this.$router.push({
        name: "login"
      });
    }
  },
  mounted: function mounted() {// 从keycloak改回hall需要修改的页面
    // 1、main.js中注释掉keyclo引用
    // 2、routerData中将office中的 '@/views/office/Office.vue' 改为 '@/views/office/OfficeForHall.vue'
  },
  destroyed: function destroyed() {},
  methods: _objectSpread(_objectSpread({}, mapActions(["setUserData", "logout", "setUserToken"])), {}, {
    fetchUserData: function () {
      var _fetchUserData = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var _this2 = this;

        var loading;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                loading = this.$loading({
                  lock: true,
                  text: "正在加载，请稍后",
                  background: "rgba(0, 0, 0, 0.7)"
                });
                this.$http.all([this.getUserInfo(), this.getPermissionMenu()]).then(this.$http.spread(function (userInfo, routerData) {
                  if (userInfo.data.resCode != 0) {
                    setTimeout(function () {
                      _this2.logout();
                    }, 2000);
                  } else if (routerData.data.resCode != 0) {
                    setTimeout(function () {
                      _this2.logout();
                    }, 2000);
                  } else {
                    _this2.setUserData(_objectSpread(_objectSpread({}, userInfo.data.resData), {}, {
                      routerData: [].concat(_toConsumableArray(routerData.data.resData), ["/test"])
                    }));

                    _this2.$nextTick(function () {
                      loading.close();

                      _this2.addRouter();
                    });
                  }
                })).catch(function () {
                  _this2.logout();
                });

              case 2:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function fetchUserData() {
        return _fetchUserData.apply(this, arguments);
      }

      return fetchUserData;
    }(),
    getUserInfo: function () {
      var _getUserInfo = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                return _context2.abrupt("return", this.$http.get("/web/getUserInfo"));

              case 1:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function getUserInfo() {
        return _getUserInfo.apply(this, arguments);
      }

      return getUserInfo;
    }(),
    getPermissionMenu: function () {
      var _getPermissionMenu = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                return _context3.abrupt("return", this.$http.get("/menu/getPermissionMenu"));

              case 1:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      function getPermissionMenu() {
        return _getPermissionMenu.apply(this, arguments);
      }

      return getPermissionMenu;
    }(),
    addRouter: function addRouter() {
      var routerData = AddRouterFunc.getNewRouerData(this.userData.routerData);
      this.$router.addRoutes(routerData);
    },
    refresh: function refresh() {
      var _this3 = this;

      this.refreshActive = false;
      this.$nextTick(function () {
        _this3.refreshActive = true;
      });
    }
  }),
  watch: {
    userToken: function userToken(value) {
      if (!value) {
        window.location.reload();
      }
    }
  },
  filters: {}
};